export const LOCALES = ['es', 'fr', 'de', 'nl', 'pt-BR'] as const;
export type Locale = (typeof LOCALES)[number];

export const LOCALE_META: Record<string, { name: string; native: string }> = {
  es: { name: 'Spanish', native: 'Español' },
  fr: { name: 'French', native: 'Français' },
  de: { name: 'German', native: 'Deutsch' },
  nl: { name: 'Dutch', native: 'Nederlands' },
  'pt-BR': { name: 'Portuguese', native: 'Português (BR)' },
};

const DECK_NAMES: Record<string, string> = {
  first_date: 'First Date', party_mode: 'Party Mode',
  spicy: 'Spicy', work_friends: 'Work Friends',
};

/** Human label for a row, e.g. "Personalized · Spicy · psp-0084". */
export function describe(row: { kind: string; deck: string | null; prompt_id: string | null; field: string }) {
  if (row.kind === 'deck' && row.deck) {
    const personalized = row.deck.startsWith('personalized');
    const base = row.deck.replace(/^(general|personalized)_/, '');
    return `${personalized ? 'Personalized' : 'General'} · ${DECK_NAMES[base] ?? base} · ${
      row.field === 'instruction' ? 'instruction' : 'question'
    }`;
  }
  if (row.kind === 'ui') return 'App interface';
  return 'App Store listing';
}

export const FLAG_LABELS: Record<string, string> = {
  placeholder_mismatch: 'Placeholder mismatch',
  minplayers_mismatch: 'Player count differs',
  format_mismatch: 'Format specifier mismatch',
  missing: 'Not translated',
  unaligned: 'Awaiting alignment',
  over_limit: 'Too long for the App Store',
};
